import { HttpClient } from '@shared/adapters/HttpClient';

export interface ZoneOutOfCoverageErrorRequest {
  action: 'retry' | 'assign';
  courier_integration_id?: number;
  courier_service_id?: number;
}

export interface ZoneOutOfCoverageErrorResponse {
  success: boolean;
  message: string;
}

export class ZoneOutOfCoverageErrorApiAdapter {
  constructor(private httpClient: HttpClient) {}

  async solveZoneOutOfCoverageError(
    orderId: number,
    data: ZoneOutOfCoverageErrorRequest
  ): Promise<ZoneOutOfCoverageErrorResponse> {
    try {
      console.log(
        '🔍 ZoneOutOfCoverageErrorApiAdapter - Solving zone out of coverage error:',
        {
          orderId,
          data,
        }
      );

      const response = await this.httpClient.put(
        `/orders/${orderId}/solve-error/zone-out-of-coverage`,
        data
      );

      console.log(
        '🔍 ZoneOutOfCoverageErrorApiAdapter - Response:',
        response
      );

      return {
        success: true,
        message:
          response.message ||
          'Error de zona fuera de cobertura resuelto correctamente',
      };
    } catch (error: any) {
      console.log('🔍 ZoneOutOfCoverageErrorApiAdapter - Error:', error);
      throw error;
    }
  }
}

